// extracted by mini-css-extract-plugin
module.exports = {"RV-L":"L_RV-L__8T1sI"};